import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Pagination } from '@core/models/pagination.model';
import { LoadingService } from '@core/services/loading.service';
import { MutualFundService } from '@core/services/mutual-fund.service';
import { FilterDropdownItemComponent } from '@shared/ui/filter-dropdown-item/filter-dropdown-item.component';
import { FiltersComponent } from '@shared/ui/filters/filters.component';
import { SlideInRightModalComponent } from '@shared/ui/slide-in-right-modal/slide-in-right-modal.component';
import { TableSkeletonLoaderComponent } from '@shared/ui/table-skeleton-loader/table-skeleton-loader.component';
import { IFILTER } from 'app/app.constants';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-mutual-funds-history',
  standalone: true,
  imports: [
    CommonModule,
    SlideInRightModalComponent,
    TableSkeletonLoaderComponent,
    FiltersComponent,
  ],
  templateUrl: './mutual-funds-history.component.html',
  styleUrl: './mutual-funds-history.component.scss',
})
export class MutualFundsHistoryComponent implements OnInit, OnDestroy {
  mutualFundService = inject(MutualFundService);
  change = inject(ChangeDetectorRef);
  activatedRoute = inject(ActivatedRoute);
  loadingService = inject(LoadingService);

  isFetchingTransactionHistoryList$!: Observable<boolean>;
  private transactionHistoryListSubject = new BehaviorSubject<any>(null);
  transactionHistoryList$ = this.transactionHistoryListSubject.asObservable();
  accountNumber = this.activatedRoute.snapshot.params['account_number'];

  subs: Subscription[] = [];

  filterStructure: IFILTER[] = [
    {
      filterKey: 'start_date',
      label: 'Start Date',
      type: 'date',
    },
    {
      filterKey: 'end_date',
      label: 'End Date',
      type: 'date',
    },
  ];

  constructor() {
    this.isFetchingTransactionHistoryList$ =
      this.loadingService.getLoadingObservable(
        'get-mutual-funds-transactions-list'
      );
  }

  ngOnInit() {
    this.filterMutualFundsListEventListener();
    this.getMutualFundsList();
  }

  filterMutualFundsListEventListener() {
    this.activatedRoute.queryParams.subscribe((params) => {
      const startDate = params[this.filterStructure[0].filterKey];

      const endDate = params[this.filterStructure[1].filterKey];

      if (startDate && endDate) {
        this.getMutualFundsList(new Pagination(), startDate, endDate);
      } else {
        this.getMutualFundsList(new Pagination());
      }
    });
  }

  getMutualFundsList(
    page: Pagination = new Pagination(),
    start_date?: string,
    end_date?: string
  ) {
    const sub = this.mutualFundService
      .getIndividualMutualFundsTransactionsList(
        page,
        this.accountNumber,
        start_date,
        end_date
      )
      .subscribe({
        next: (res) => {
          this.transactionHistoryListSubject.next(res.data.data);
          this.change.detectChanges();
        },
        error: () => {},
      });
    this.subs.push(sub);
  }

  ngOnDestroy() {
    this.subs.forEach((sub) => sub.unsubscribe());
  }
}
